import { APIClient } from '@customerio/hydra-ui-api';
import { getApiBaseUrl, getAuthHeaders } from '@/services/api';
import { recordRumRequest } from '@/services/rum';

/**
 * The run-stream route is not in the generated UI API spec yet, so this hand-written
 * `paths` type gives the shared transport its types until the spec carries it.
 */
interface CopilotStreamPaths {
  '/v1/accounts/{account_id}/copilot/{session_id}/stream': {
    get: {
      parameters: { path: { account_id: string; session_id: string } };
      responses: { 200: { content: { 'application/json': unknown } }; 204: { content?: never } };
    };
  };
}

export const copilotStreamApi = new APIClient<CopilotStreamPaths>({
  baseUrl: getApiBaseUrl,
  fetchOptions: { credentials: 'include' },
  headers: getAuthHeaders,
  onRequestTiming: recordRumRequest,
});
